<img
    [width]="size"
    src="./assets/kinvent_logo_500x500.png"
    alt="KInvent Logo"
/>
